import { Form } from '@carboledger/ui';
import { useTranslations } from '@/hooks';
import { AllocationPreferenceField, FeedstockCategoryField } from '@/components/common';

/**
 * Props:
 *   formOptions  useValidateDeclarationFormOptions() result
 */
export const AllocationRulesSection = ({ formOptions }) => {
  const t = useTranslations();

  return (
    <Form.Section title={t('SECTION_ALLOCATION_RULES')}>
      <Form.Row columns={2}>
        <FeedstockCategoryField options={formOptions.feedstockCategoryOptions} />

        <AllocationPreferenceField options={formOptions.allocationPreferenceOptions} />
      </Form.Row>
    </Form.Section>
  );
};
